import getLayerStore from '@stores/LayerStore';
import { formatPrice } from '@lib/utils';
import { WidgetItem } from './Item';
import { StyledWidgetWrapper } from './style';

import type { LayerInfo } from '@lib/types';
import type React from 'react';

const LayerStore = getLayerStore();
const date = new Date();

type Props = {
  layer: LayerInfo;
};

export const WidgetWrapper: React.FC<Props> = () => {
  if (
    !LayerStore.offeringsAmount ||
    (!LayerStore.offeringsAmount.housesToBuy && !LayerStore.offeringsAmount.apartmentsToBuy)
  ) {
    return null;
  }

  return (
    <StyledWidgetWrapper>
      {LayerStore.offeringsAmount.housesToBuy && (
        <WidgetItem
          count={formatPrice(LayerStore.offeringsAmount.housesToBuy)}
          label={`Häuser zum Verkauf (${date.getFullYear()})`}
        />
      )}
      {LayerStore.offeringsAmount.apartmentsToBuy && (
        <WidgetItem
          count={formatPrice(LayerStore.offeringsAmount.apartmentsToBuy)}
          label={`Wohnungen zum Verkauf (${date.getFullYear()})`}
        />
      )}
    </StyledWidgetWrapper>
  );
};
